import { createAction } from '@reduxjs/toolkit';
import { SingleUser } from '../../api/types';
import { DossierMember, DossierMemberInterface } from '../../models/DossierMember';
import { DossierV2, IDossierV2 } from '../../models/DossierV2';

export enum ESessionActionType {
  SET_DOSSIER = 'session/dossier/set',
  CLEAR_DOSSIER = 'session/dossier/clear',
  SET_USER = 'session/user/set',
  CLEAR_USER = 'session/user/clear',
  SET_MULTI_DOSSIER_USER = 'session/multi-dossier-user/set',
}

export interface ISetSessionDossier {
  dossier: DossierV2;
  relation?: DossierMember;
  dossierRelations: DossierMember[];
}

export const sessionActions = {
  setDossier: createAction(ESessionActionType.SET_DOSSIER, (data: ISetSessionDossier) => {
    const dossier: IDossierV2 = { ...data.dossier, createdAt: data.dossier.createdAt.toString(), lastActivityAt: data.dossier.lastActivityAt.toString() };
    const relation: DossierMemberInterface|undefined = data.relation && { ...data.relation, user: data.relation.user.toSingleUser() };
    const dossierRelations: DossierMemberInterface[] = data.dossierRelations.map(relation => ({ ...relation, user: relation.user.toSingleUser() }));
    return {
      payload: {
        dossier,
        relation,
        dossierRelations,
      }
    };
  }),
  clearDossier: createAction<void>(ESessionActionType.CLEAR_DOSSIER),
  setUser: createAction<SingleUser>(ESessionActionType.SET_USER),
  clearUser: createAction<void>(ESessionActionType.CLEAR_USER),
  setMultiDossierUser: createAction<boolean>(ESessionActionType.SET_MULTI_DOSSIER_USER),
};
